"use strict";

function timeout(time) {
  return new Promise(function (resolve) {
    setTimeout(resolve, time);
  });
}

module.exports = timeout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/core/utils/timeout.js
// module id = 0onF
// module chunks = 88